<form novalidate [formGroup]="paymentMethodForm()">
  <div class="grid">
    <div id="payment-method-details" class="col-12 md:col-6">
      <h5>{{ 'ARC_PAYMENT_METHOD_DETAILS' | translate }}</h5>
      @if (showCardOverrideButton()) {
      <div>
        <button
          aur-button
          id="card-override-button"
          (click)="onCardOverrideClick()"
        >
          {{ 'ARC_PAYMENT_METHOD_CARD_OVERRIDE' | translate }}
        </button>
      </div>
      } @else if (showPaymentToggle()) {
      <div>
        <aur-field-wrapper label="{{ 'ARC_PAYMENT_TYPE' | translate }}">
          <p-selectButton
            id="paymentToggle"
            [options]="paymentMethodOptions"
            allowEmpty="false"
            (onOptionClick)="toggleChanged()"
            formControlName="selectedPaymentMethod"
          >
          </p-selectButton>
        </aur-field-wrapper>
      </div>
      }
      <div>
        <div id="paymentToggleWrapper">
          @switch (selectedPaymentMethodType) { @case(paymentMethodType.CREDIT){
          <div class="credit-input-container">
            <aur-credit-card-group
              [redacted]="false"
              [showCard]="true"
              [stacked]="true"
              [formGroup]="creditCardGroup"
              [hideAcceptedCreditCardLogos]="false"
              [acceptedCreditCards]="allowableCardBrands()"
              [errorMessages]="{
                expiredDate:
                  'ARC_PAYMENT_METHOD_CC_EXPIRATION_DATE_PAST_DATE_ERROR',
                invalidFormat: 'ARC_PAYMENT_DATE_FORMAT_ERROR',
                accountNumberMatchesType:
                  'ARC_PAYMENT_ALLOWABLE_CARDBRANDS_CREDITCARD_NUMBER_ERROR'
              }"
            ></aur-credit-card-group>
          </div>
          } @case (paymentMethodType.ACH) {
          <div class="ach-input-container">
            <aur-ach-group
              class="add-payment-aur-ach-group"
              [formGroup]="achForm"
              [country]="userCountry()"
              [examplePosition]="'bottom'"
            ></aur-ach-group>
          </div>
          } }
        </div>
      </div>
    </div>

    <div id="billing-address" class="col-12 md:col-6">
      <div class="box box-stretched">
        <div formGroupName="billingInformation">
          <h5>{{ 'ARC_PAYMENT_BILLING_ADDRESS' | translate }}</h5>
          <aur-address-group
            id="aur-address"
            [formGroup]="addressGroup"
            [errorMessages]="errorMessages"
          >
          </aur-address-group>
        </div>
        @if(showSavePaymentAccount()) {
        <div>
          <p-checkbox
            id="save-payment-account"
            class="form-control"
            formControlName="savePaymentAccount"
            name="savePaymentAccount"
            label="{{ 'ARC_PAYMENT_SAVE_PAYMENT_ACCOUNT' | translate }}"
            [binary]="true"
          >
          </p-checkbox>
        </div>
        }
      </div>
    </div>
  </div>
</form>
